import styled from "styled-components";

import { StyledScrollableTableContent } from "app/pages/sales-intelligence/common-components/search-results-table";

export const StyledAppsTableWrapper = styled(StyledScrollableTableContent)`
    height: 100%;
`;
